export const PAYMENT_DEPLOY_ENV =
  process.env.REACT_APP_PAYMENT_DEPLOY_ENV || "local";

const PRODUCTION_PAYMENT_BACKEND_URL = "https://mystylistpro-backend.onrender.com";
const PRODUCTION_APP_ENTRY_URL = "https://app.my-stylist.pro";

const requireBrowserEnv = (name) => {
  const value = process.env[name];

  if (!value) {
    throw new Error(`${name} is required for the payment frontend build`);
  }

  return value;
};

const requireUrlEnv = (name) => {
  const value = requireBrowserEnv(name);

  try {
    return new URL(value).toString().replace(/\/$/, "");
  } catch {
    throw new Error(`${name} must be a valid URL`);
  }
};

const assertDeployEnvironment = () => {
  if (!["local", "staging", "production"].includes(PAYMENT_DEPLOY_ENV)) {
    throw new Error(
      "REACT_APP_PAYMENT_DEPLOY_ENV must be one of local, staging, or production",
    );
  }
};

const assertStripePublishableKey = (value) => {
  if (!value.startsWith("pk_test_") && !value.startsWith("pk_live_")) {
    throw new Error("REACT_APP_STRIPE_PUBLIC_KEY must be a Stripe publishable key");
  }

  if (PAYMENT_DEPLOY_ENV === "production" && !value.startsWith("pk_live_")) {
    throw new Error("Production payment builds must use a pk_live Stripe key");
  }

  if (PAYMENT_DEPLOY_ENV !== "production" && value.startsWith("pk_live_")) {
    throw new Error("Non-production payment builds must not use a pk_live Stripe key");
  }
};

const assertNonProductionUrl = (name, value, productionValue) => {
  if (PAYMENT_DEPLOY_ENV !== "production" && value === productionValue) {
    throw new Error(`${name} must not point at production outside production`);
  }
};

assertDeployEnvironment();

export const STRIPE_PUBLIC_KEY = requireBrowserEnv("REACT_APP_STRIPE_PUBLIC_KEY");
assertStripePublishableKey(STRIPE_PUBLIC_KEY);

export const TRIAL_DAYS = 7;

export const API_URL = requireUrlEnv("REACT_APP_PAYMENT_BACKEND_API_URL");
assertNonProductionUrl(
  "REACT_APP_PAYMENT_BACKEND_API_URL",
  API_URL,
  PRODUCTION_PAYMENT_BACKEND_URL,
);

export const STRIPE_PRICE_ID = requireBrowserEnv("REACT_APP_STRIPE_PRICE_ID");

export const EU_STRIPE_PRICE_ID = requireBrowserEnv("REACT_APP_EU_STRIPE_PRICE_ID");

export const REDIRECT_LINK = "https://quiz.my-stylist.pro/quiz/color-palette";

export const POST_PURCHASE_APP_ENTRY_URL =
  requireUrlEnv("REACT_APP_POST_PURCHASE_APP_ENTRY_URL");
assertNonProductionUrl(
  "REACT_APP_POST_PURCHASE_APP_ENTRY_URL",
  POST_PURCHASE_APP_ENTRY_URL,
  PRODUCTION_APP_ENTRY_URL,
);

export { requireBrowserEnv };

export const product = {
  id: 0,
  trialPrice: 0.99,
  oldPrice: "$59.99",
  safePercent: 54,
  price: 27.99,
  pricePerMonth: "$2.29 / month",
  priceId: STRIPE_PRICE_ID,
  text: "$0.99",
};

export const baseInputStyle = {
  color: "#325761",
  fontWeight: "400",
  fontFamily: "SF, sans-serif",
  fontSize: "17px",
  fontSmoothing: "antialiased",
  ":-webkit-autofill": {
    color: "#D9D9D9",
    backgroundColor: "transparent",
  },
  "::placeholder": {
    color: "transparent",
    fontFamily: "SF, sans-serif",
    fontWeight: 400,
    fontSize: 17,
    display: "none",
    content: "",
  },
};

export const trialObject = {
  value: "1",
  text: "$1",
  trialValue: 0.99,
  trialValueText: "$0.99",
  willBeText:
    "Then your yearly Subscription Period will start and you will be charged $27.99 every quarter. No refunds if canceled before the end of Subscription Period.",
};
